const ɵ0 = {
    'SAMPLE': {
        'HELLO': 'Hello, World!'
    }
};
export const locale = {
    lang: 'en',
    data: ɵ0
};
export { ɵ0 };
